import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FullscreenService } from './../../../../core/services/fullscreen.service';
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ConsultationsService } from '../../../../core/services/consultation/consultations.service';
import {
  catchError,
  interval,
  map,
  Observable,
  of,
  Subscription,
  switchMap,
  takeWhile,
} from 'rxjs';
import { PatientsService } from '../../../../core/services/patient/patients.service';
import { CurrentUserService } from '../../../../core/services/user/current-user.service';
import { ChatService } from '../../../../core/services/chat/chat.service';
import { CreateChatModel } from '../../../../core/models/chat/create-chat-model';
import { StatusUtils } from '../../../../utils/status-utils';
import { SignalRService } from '../../../../core/services/signalR/signalR';
import { environment } from '../../../../../environments/environment';
import { CaseStatus } from '../../../../../enums/case-status.enum';
import { FullscreenOverlayComponent } from '../../../components/fullscreen-overlay/fullscreen-overlay.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  localizeNamedReference,
  mapToNamedReferences,
} from '../../../../core/utils/health-profile-i18n';
import { UserSessionModel } from '../../../../core/models/user/current-user.model';
import { ConclusioOptions } from '../../../../core/models/consultation/conclusion-options.model';
import { TimelineListModel } from '../../../../core/models/consultation/timeline-list.model';
import { ChatListModel } from '../../../../core/models/chat/chat-list.model';
import { NotificationTemplateModel } from '../../../../core/models/notification/notification-template.model';
import { AiImagesModel } from '../../../../core/models/consultation/ai-images.model';
import { SkinTypes } from '../../../../../enums/skin-types.enum';
import { ImgEditorComponent } from '../../../components/img-editor/img-editor.component';
import { CaseBreadcrumbComponent } from '../../../components/case-breadcrumb/case-breadcrumb.component';
import { GaugeChartComponent } from '../../../components/gauge-chart/gauge-chart.component';
import { BodyMapViewerComponent } from '../../../components/body-map-viewer/body-map-viewer.component';
import { PatientCaseModel } from '../../../../core/models/consultation/patient-case.model';
import { SelectedConclusionModel } from '../../../../core/models/consultation/selected-conclusion.model';
import { AnnotationListModel } from '../../../../core/models/consultation/annotation-list.model';
import { UserRole } from '../../../../../enums/roles.enum';
import {
  ADVANCED_EXAMINATION,
  COLOR_OPTION_ID,
  BORDER_OPTION_ID,
  IRREGULAR_STREAKS_PSEUDOPODS_ID,
  LENTIGO_MALIGNA_ID,
  MELANOMA_ID,
  RECOMMENDATION_OPTION_ID,
} from '../../../constants/constants';
import { ToastService } from '../../../../core/services/toast.service';
import { SelectedOptionModel } from '../../../../core/models/consultation/selected-option.model';
import { SelectedOptionsArrayModel } from '../../../../core/models/consultation/selected-options-array.model';
import { UsersService } from '../../../../core/services/user/users.service';
import {
  BENIGN_SKIN_CONDITIONS,
  PRE_MALIGNANT_SKIN_CONDITIONS,
  MALIGNANT_SKIN_CONDITIONS,
} from '../../../constants/constants';
import { DiagnosisSubcategoryModel } from '../../../../core/models/consultation/diagnosis-subcategory-model.model';
import { SkinAnalysisMetricsModel } from '../../../../core/models/consultation/skin-analysis-metrics.model';
import {
  DermAiCaseListModel,
  DermAiFollowUpHistoryItem,
  DermAiRelatedCaseModel,
} from '../../../../core/models/patient/derm-ai-case-list.model';
declare var bootstrap: any;
import { InputValidationService } from '../../../../core/services/input-validation.service';

@Component({
  selector: 'app-derm-ai-consultation',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    FullscreenOverlayComponent,
    TranslateModule,
    ImgEditorComponent,
    CaseBreadcrumbComponent,
    GaugeChartComponent,
    BodyMapViewerComponent,
    RouterModule,
  ],
  templateUrl: './derm-ai-consultation.component.html',
  styleUrl: './derm-ai-consultation.component.scss',
  providers: [DatePipe],
})
export class DermAiConsultationComponent {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('chatContainer') chatContainer!: ElementRef;
  @ViewChildren('magnifierContainer') containers!: QueryList<ElementRef>;
  @ViewChildren('magnifierLens') lenses!: QueryList<ElementRef>;
  @ViewChildren('magnifierImage') images!: QueryList<ElementRef>;
  @ViewChild('leftFirstTab') leftFirstTab!: ElementRef<HTMLAnchorElement>;
  @ViewChild('rightFirstTab') rightFirstTab!: ElementRef<HTMLAnchorElement>;

  caseStatus = CaseStatus;
  constructor(
    private inputValidationService: InputValidationService,
    private fullscreenService: FullscreenService,
    private route: ActivatedRoute,
    private consultationsService: ConsultationsService,
    private patientsService: PatientsService,
    private usersService: UsersService,
    private chatService: ChatService,
    private currentUserService: CurrentUserService,
    private signalRService: SignalRService,
    private router: Router,
    private translate: TranslateService,
    private toastService: ToastService,
    private ch: ChangeDetectorRef
  ) {
    const userLang = localStorage.getItem('selectedLanguage') || 'en';
    this.translate.use(userLang);

    // DermoScan: chat disabled
    // this.createChatConnection();
    // this.createPatientImageConnection();
  }
  selectedItem: any;
  consultationId: string = '';
  activeCase: PatientCaseModel;
  patientRecordId: string = '';
  mobileCaseId: string = '';
  private dermoScanLockToken: string | null = null;
  private dermoScanLockedCaseId: string | null = null;
  private dermoScanLockHeartbeat: any;
  private dermoScanLockSubmitted = false;
  dermAiCase: DermAiCaseListModel | null = null;
  private hasResolvedInitialFollowUpCase = false;
  patientCases: PatientCaseModel[];
  selectedConclusionOptions: SelectedConclusionModel[] = [];
  patientHeaderInformations: any = [];
  patientRecordCaseImages: any = [];
  isImagesLoading: boolean = true;
  private caseImageObjectUrls: string[] = [];
  private caseImageLoadGeneration = 0;
  timeLineList: TimelineListModel[] = [];
  patientCaseDetails: any = [];
  selectedIndex: number | null = null;
  currentUser: UserSessionModel | null = null;
  conclusionOptions: ConclusioOptions[] = [];
  selectedConclusionText: string = '';
  selectedConclusions: { [key: string]: string } = {};
  pdfSrc: any = null;
  patientRapport: any = null;
  isConsultationReportTabActive = false;
  private tabChangeListener: any;
  chatList: ChatListModel[] = null;
  messageText: string = '';
  file: File | null = null;
  fileCount: any = null;
  private interval: any;
  reportError: string = '';
  userInput: string = '';
  isUpdatingFromInput = false;
  previewReportErrorText: string = '';
  statusClass: string;
  statusText: string;
  isOverlayLoading: boolean = false;
  isChatSending: boolean = false;
  selectedImage: any = null;
  radioSelectedImage: any = null;
  showImageGallery: boolean = true;
  patientHistoryImages: any = [];
  patientCaseReportImages: any;
  currentCaseData: {
    src: any;
    isSelected: boolean;
    isReportImage: boolean;
    imageId: string;
    patientRecordCaseId: string;
  } = {
      src: null,
      isSelected: false,
      isReportImage: false,
      imageId: '',
      patientRecordCaseId: '',
    };
  historyCaseDataList: Array<{
    src: string | null;
    isSelected: boolean;
    isReportImage: boolean;
    imageId: string;
    patientRecordCaseId: string;
  }> = [];
  fullscreenImage: {
    src: any;
    isSelected: boolean;
    isReportImage: boolean;
    imageId: string;
    patientRecordCaseId: string;
  } = {
      src: null,
      isSelected: false,
      isReportImage: false,
      imageId: '',
      patientRecordCaseId: '',
    };
  selectedImageIndex: number = 0;
  allCaseImageTabVisibilty: boolean = false;
  activeTab: '#caseImage' | '#allCaseImages' | '#bodyMap' = '#caseImage';
  activeRightTab: '#conclusion' | '#aiReport' | '#caseHistory' | '#chatWithGp' =
    '#conclusion';
  notificationTemplate: NotificationTemplateModel = {
    id: '',
    subject: '',
    body: '',
    notificationType: 0,
  };
  notificationMailTemplate: any;
  aiImages: AiImagesModel = {
    gaugeImage: '',
    radarChartImage: '',
    lesionSpaceImage: '',
    cbirImage: '',
    blendedImage: '',
    spaceImage: '',
    saturationSpaceImage: '',
    cbir1Image: '',
    cbir2Image: '',
    cbir3Image: '',
    cbir4Image: '',
    cbir5Image: '',
    gaugeRate: '',
    cbir1Value: '',
    cbir2Value: '',
    cbir3Value: '',
    cbir4Value: '',
    cbir5Value: '',
    allImagesExist: false,
  };
  firstImage: any = [];
  showFullText: boolean = false;
  showMedicationFullText: boolean = false;
  showImageGalleryAi: boolean = true;
  isAiLoading: boolean = true;
  fullscreenImageAi: any = null;
  subscription: Subscription;
  defaultUserImage: string | ArrayBuffer | null = null;
  currentUserAvatar: string | ArrayBuffer | null = null;
  otherUserAvatar: string | ArrayBuffer | null = null;
  otherUserName: string = '';
  annotationList: AnnotationListModel[] = [];
  drawnRects: any[] = [];
  userRole = UserRole;
  selectedOption: SelectedOptionModel = {
    id: '',
    title: '',
    conclusionText: '',
    conclusionOptionId: '',
    applicationCode: 0,
  };
  isComeFromReferral: boolean = false;
  selectedOptionsArray: SelectedOptionsArrayModel[] = [];
  diagnoses: { id: string; name: string; order: number }[] = [];
  benignSubcategories: DiagnosisSubcategoryModel[] = [];
  preMalignantSubcategories: DiagnosisSubcategoryModel[] = [];
  malignantSubcategories: DiagnosisSubcategoryModel[] = [];
  selectedDiagnosis: string = '';
  selectedSubcategory: string = '';
  benignSkinConditions = BENIGN_SKIN_CONDITIONS;
  preMalignantSkinConditions = PRE_MALIGNANT_SKIN_CONDITIONS;
  malignantSkinConditions = MALIGNANT_SKIN_CONDITIONS;
  activeTabList: string[] = [];
  showDisableButtonDesc: boolean = false;
  enEvent: boolean = false;
  isRecommendationDisabled = false;
  ADVANCED_EXAMINATION_ID = ADVANCED_EXAMINATION;
  RECOMMENDATION_OPTION_ID = RECOMMENDATION_OPTION_ID;
  recommendationOption: any = null;
  selectedAIReportSection: 'tdsScoring' | 'asymmetry' | 'borderIrregularity' | 'color' | 'diameter' = 'tdsScoring';
  skinAnalysisMetrics: SkinAnalysisMetricsModel | null = null;

  readonly isDebugDomain: boolean = (() => {
    const host = window.location.hostname;
    return host === 'localhost' || host === 'dermalogic.amatis.dev';
  })();


  async ngOnInit() {
    await StatusUtils?.initializeTranslateService(this.translate);
    this.fullscreenService.initializeFullscreenButtons();
    this.patientRecordId = this.route.snapshot.paramMap.get('id')!;
    this.mobileCaseId = this.patientRecordId;
    this.consultationId = this.patientRecordId;
    this.getDermAiCaseData();
    this.currentUser = this.currentUserService.GetSession();
    this.isComeFromReferral = window.location.href.includes('referral')
      ? true
      : false;
    this.getConclusionOptions();
    this.getDiagnoseTypeCategoryList();

    // MOCK DATA INJECTION FOR MOCKUP REQUEST
    // this.setMockData(); // Devre dışı - gerçek backend verisi test edilecek
  }

  ngAfterViewInit() {
    this.tabChangeListener = this.handleTabChange.bind(this);
    document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
      tab.addEventListener('shown.bs.tab', this.tabChangeListener);
    });

    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new bootstrap.Tooltip(tooltipTriggerEl, {
        customClass: 'custom-tooltip',
        placement: 'bottom',
      });
    });
  }

  ngAfterViewChecked() {
    if (!this.enEvent) {
      this.containers.forEach((containerRef, index) => {
        const container = containerRef.nativeElement;
        const lens = this.lenses.toArray()[index].nativeElement;
        const image = this.images.toArray()[index].nativeElement;

        if (container && lens && image) {
          this.enEvent = true;
          container.addEventListener('mousemove', (e: MouseEvent) => {
            const { top, left, width, height } =
              container.getBoundingClientRect();
            const lensSize = lens.offsetWidth / 2;
            lens.style.display = 'block';
            let x = e.pageX - left - lensSize;
            let y = e.pageY - top - lensSize;

            if (x > width - lensSize * 2) x = width - lensSize * 2;
            if (y > height - lensSize * 2) y = height - lensSize * 2;
            if (x < 0) x = 0;
            if (y < 0) y = 0;

            lens.style.left = x + 'px';
            lens.style.top = y + 'px';
            lens.style.backgroundImage = `url(${image.src})`;
            lens.style.backgroundPosition = `-${x * 2}px -${y * 2}px`;
            lens.style.backgroundSize = `${width * 2}px ${height * 2}px`;
          });

          container.addEventListener('mouseleave', () => {
            lens.style.display = 'none';
          });
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.clearDermoScanLockHeartbeat();
    this.releaseDermoScanLock();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
      tab.removeEventListener('shown.bs.tab', this.tabChangeListener);
    });
    this.revokeCaseImageObjectUrls();
  }

  setUserPermission(): Boolean {
    return (
      this.currentUser?.role === UserRole.Dermatologist ||
      this.currentUser?.role === UserRole.GeneralPractitioner ||
      this.currentUser?.role === UserRole.Admin ||
      this.currentUser?.role === UserRole.OrganizationAdmin
    );
  }

  selectTab(
    tab: 'conclusion' | 'aiReport' | 'caseHistory' | 'chatWithGp'
  ) {
    this.activeTabList.push(tab);

    if (tab === 'conclusion') {
      this.activeRightTab = '#conclusion';
    } else if (tab === 'aiReport') {
      this.activeRightTab = '#aiReport';
      this.ch.detectChanges();

      if (
        ['asymmetry', 'borderIrregularity', 'color', 'diameter'].includes(
          this.selectedAIReportSection
        )
      ) {
        setTimeout(() => this.renderCharts(), 100);
      }
    } else if (tab === 'caseHistory') {
      this.activeRightTab = '#caseHistory';
    } else {
      this.activeRightTab = '#chatWithGp';
    }
  }

  get hasDermAiAnalysisMetrics(): boolean {
    return !!this.skinAnalysisMetrics?.analysis;
  }

  get malignancyRate(): number {
    const probability =
      this.skinAnalysisMetrics?.analysis?.classification?.malignantProbability ??
      this.skinAnalysisMetrics?.malignantProbability ??
      0;
    return probability * 100;
  }

  get malignancyRateString(): string {
    return this.malignancyRate.toFixed(1);
  }

  onDiagnosisChange() {
    this.selectedSubcategory = '';

    this.consultationsService
      .diagnoseTypeContentListByCategory(this.selectedDiagnosis)
      .subscribe({
        next: (res) => {
          if (this.selectedDiagnosis === this.benignSkinConditions) {
            this.benignSubcategories = res;
          } else if (
            this.selectedDiagnosis === this.preMalignantSkinConditions
          ) {
            this.preMalignantSubcategories = res;
          } else if (this.selectedDiagnosis === this.malignantSkinConditions) {
            this.malignantSubcategories = res;
          }
        },
      });
  }

  getSelectedSubcategoryObj(): DiagnosisSubcategoryModel | undefined {
    if (this.selectedDiagnosis === this.benignSkinConditions) {
      return this.benignSubcategories.find(x => x.id === this.selectedSubcategory);
    } else if (this.selectedDiagnosis === this.preMalignantSkinConditions) {
      return this.preMalignantSubcategories.find(x => x.id === this.selectedSubcategory);
    } else if (this.selectedDiagnosis === this.malignantSkinConditions) {
      return this.malignantSubcategories.find(x => x.id === this.selectedSubcategory);
    }
    return undefined;
  }

  onSubcategoryChange(type: 'benign' | 'preMalignant' | 'malignant') {
    if (type === 'benign') {
      this.selectedConclusionText = this.benignSubcategories.find(
        (x) => x.id === this.selectedSubcategory
      )?.description;
      this.isRecommendationDisabled = false;
    } else if (type === 'preMalignant') {
      this.selectedConclusionText = this.preMalignantSubcategories.find(
        (x) => x.id === this.selectedSubcategory
      )?.description;
      this.isRecommendationDisabled = false;
    } else if (type === 'malignant') {
      const selected = this.malignantSubcategories.find(
        (x) => x.id === this.selectedSubcategory
      );
      if (
        selected?.id === LENTIGO_MALIGNA_ID ||
        selected?.id === MELANOMA_ID
      ) {
        this.isRecommendationDisabled = true;

        this.recommendationOption = this.selectedConclusionOptions.find(
          (x) => x.optionId === RECOMMENDATION_OPTION_ID
        );
        if (this.recommendationOption) {
          this.recommendationOption.conclusionTextId = ADVANCED_EXAMINATION;
          const foundOption = this.conclusionOptions.find(options => RECOMMENDATION_OPTION_ID === options.id);
          if (foundOption) {
            const foundContent = foundOption.conclusionOptionContents.find(content => ADVANCED_EXAMINATION === content.id);
            if (foundContent) {
              this.recommendationOption.conclusionText = foundContent.conclusionText;
            }
          }
        }
      } else {
        this.isRecommendationDisabled = false;
      }
    }
  }

  annotationListChange(e: { annotationList: any[]; drawnRects: any[] }) {
    this.annotationList = e.annotationList;
    this.drawnRects = e.drawnRects;
    this.setSelectedConsultationText();
  }

  async saveCaseAndNext() {
    if (!this.mobileCaseId) return;

    this.patientsService
      .submitMobilePatientCaseConclusion(
        this.buildMobileConclusionPayload(this.mobileCaseId)
      )
      .subscribe({
        next: () => {
          this.markDermoScanLockSubmitted();
          this.activeCase.isCaseCompleted = true;
          this.activeCase.isRecordCompleted = 'true';
          this.goToNextCase();
        },
      });
  }

  goToNextCase() {
    const currentCaseIndex = this.patientCases.findIndex(
      (x) => x.patientRecordCaseId === this.activeCase.patientRecordCaseId
    );
    const nextCase = this.patientCases[currentCaseIndex + 1];
    if (!nextCase) return;

    this.activeCase = nextCase;
    this.consultationId = nextCase.patientRecordCaseId;
    this.mobileCaseId = nextCase.patientRecordCaseId;
    this.initAfterActiveCaseChange();
  }

  protected async createConsultationConnection() {
    const signalRBasePath = `${environment.apiLocations.patient}`.split(
      '/api/v1'
    )[0];
    const hubUrl = 'patient-hub';
    this.signalRService.connect(hubUrl, signalRBasePath);
    this.signalRService.on(hubUrl, 'receivePatientUpdated', signalRBasePath, (message) => {
      const parsedJson = JSON.parse(message);
      if (parsedJson?.PatientRecordCaseId === this.consultationId) {
        this.patientHeaderInformations.patientStatus = parsedJson.PatientStatus;
      }
    });
  }

  protected async closeConsultation() {
    const signalRBasePath = `${environment.apiLocations.patient}`.split(
      '/api/v1'
    )[0];
    const hubUrl = 'patient-hub';
    this.signalRService.connect(hubUrl, signalRBasePath);
    this.signalRService.on(hubUrl, 'receiveConsultationClosed', signalRBasePath, (message) => {
      const parsedJson = JSON.parse(message);
      if (parsedJson?.PatientRecordId === this.patientRecordId) {
        this.router.navigate(['/consultation/list']);
      }
    });
  }

  reset() {
    this.leftFirstTab?.nativeElement?.click();
    this.rightFirstTab?.nativeElement?.click();
    this.closeAiImagesFullscreen();
    this.showDisableButtonDesc = false;
    this.currentCaseData = {
      src: null,
      isSelected: false,
      isReportImage: false,
      imageId: '',
      patientRecordCaseId: '',
    };
    this.selectedConclusionOptions = [];
    this.selectedConclusionText = '';
    this.statusClass = '';
    this.statusText = '';
    this.patientRecordCaseImages = [];
    this.selectedImage = null;
    this.timeLineList = [];
    this.patientCaseDetails = [];
    this.patientHistoryImages = [];
    this.patientCaseReportImages = null;
    this.aiImages = {
      gaugeImage: '',
      radarChartImage: '',
      lesionSpaceImage: '',
      cbirImage: '',
      blendedImage: '',
      spaceImage: '',
      saturationSpaceImage: '',
      cbir1Image: '',
      cbir2Image: '',
      cbir3Image: '',
      cbir4Image: '',
      cbir5Image: '',
      gaugeRate: '',
      cbir1Value: '',
      cbir2Value: '',
      cbir3Value: '',
      cbir4Value: '',
      cbir5Value: '',
      allImagesExist: false,
    };
    this.chatList = null;
    this.selectedDiagnosis = '';
    this.selectedSubcategory = '';
    this.skinAnalysisMetrics = null;
    // this.setMockData(); // Devre dışı - gerçek backend verisi test edilecek
  }

  async initAfterActiveCaseChange() {
    this.reset();
    this.router.navigate(
      ['/dermoscan/dermconsultation', this.consultationId],
      { replaceUrl: true }
    );
    this.getDermAiCaseData(this.consultationId);
  }

  mouseEnterInBreadcrumb(event: MouseEvent) {
    const button = document.getElementById('myAcordionButton') as HTMLElement;
    button?.setAttribute('data-bs-toggle', '');
  }

  mouseLeaveInBreadcrumb(event: MouseEvent) {
    const button = document.getElementById('myAcordionButton') as HTMLElement;
    button?.setAttribute('data-bs-toggle', 'collapse');
  }

  // DermoScan: chat disabled
  // protected async createChatConnection() {
  //   const signalRBasePath = `${environment.apiLocations.chat}`.split(
  //     '/api/v1'
  //   )[0];
  //   const hubUrl = 'chat-hub';
  //   this.signalRService.connect(hubUrl, signalRBasePath);
  //   this.signalRService.on(hubUrl, 'receiveChatAdded', signalRBasePath, (message) => {
  //     const parsedJson = JSON.parse(message);
  //     if (parsedJson.PatientRecordCaseId === this.consultationId) {
  //       if (parsedJson?.Message) {
  //         const newMessage = {
  //           chatId: parsedJson.ChatId,
  //           patientRecordCaseId: parsedJson.PatientRecordCaseId,
  //           createdUserId: parsedJson.CreatedUserId,
  //           createdUserName: parsedJson.CreatedUserName,
  //           message: parsedJson.Message,
  //           chatFiles: parsedJson.ChatFiles || [],
  //           createdDateTime: parsedJson.CreatedDateTime,
  //           relativeTime: parsedJson.RelativeTime,
  //         };
  //         this.chatList = [...this.chatList, newMessage];
  //         setTimeout(() => {
  //           this.scrollToBottom();
  //         }, 500);
  //       }
  //     }
  //   });
  // }

  protected async createPatientImageConnection() {
    const signalRBasePath = `${environment.apiLocations.patient}`.split(
      '/api/v1'
    )[0];
    const hubUrl = 'patient-hub';
    this.signalRService.connect(hubUrl, signalRBasePath);
    this.signalRService.on(hubUrl, 'receiveImageUploaded', signalRBasePath, (message) => {
      const parsedJson = JSON.parse(message);
      if (parsedJson.PatientRecordCaseId === this.consultationId) {
        if (parsedJson) {
          const image = {
            createdDate: parsedJson.CreatedDate,
            fileData: parsedJson.FileData,
            fileName: parsedJson.FileName,
            id: parsedJson.PatientRecordCaseImageId,
            isSelected: parsedJson.IsSelected,
          };
          this.patientRecordCaseImages = [
            image,
            ...this.patientRecordCaseImages,
          ];
        }
      }
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    this.releaseDermoScanLock();
    this.revokeCaseImageObjectUrls();
  }

  removeDoctor() {
    return;
  }

  handleTabChange(event: Event) {
    const target = event.target as HTMLElement;
    const href = target.getAttribute('href');
    // DermoScan: chat tab disabled
    // if (href === '#chatWithGp') {
    //   this.activeRightTab = '#chatWithGp';
    //   this.getChatList(this.consultationId);
    //   if (
    //     this.currentUser?.role === this.userRole.OrganizationAdmin ||
    //     this.currentUser?.role === this.userRole.Assistant
    //   ) {
    //     this.isChatSending = true;
    //   }
    //   setTimeout(() => {
    //     this.scrollToBottom();
    //   }, 500);
    //   this.markMessagesAsRead(this.consultationId);
    // } else
    if (href === '#consultationHistory') {
      // DermoScan: chat disabled
      // setTimeout(() => {
      //   this.scrollToBottom();
      // }, 500);
    } else if (href === '#conclusion') {
      this.activeRightTab = '#conclusion';
    } else if (href === '#aiReport') {
      this.activeRightTab = '#aiReport';
      this.ch.detectChanges();
      // Render charts if the current section has a chart
      if (['asymmetry', 'borderIrregularity', 'color', 'diameter'].includes(this.selectedAIReportSection)) {
        setTimeout(() => this.renderCharts(), 100);
      }
    } else if (href === '#caseHistory') {
      this.activeRightTab = '#caseHistory';
    } else if (href === '#allCaseImages') {
      this.activeTab = '#allCaseImages';
    } else if (href === '#bodyMap') {
      this.activeTab = '#bodyMap';
    } else if (href === '#caseImage') {
      this.activeTab = '#caseImage';
    }
  }

  // DermoScan: chat disabled
  // markMessagesAsRead(caseId: string) {
  //   this.chatService.markMessagesAsRead(caseId).subscribe({
  //     next: () => { },
  //   });
  // }

  getAIReport(id: string) {
    this.consultationsService
      .patientRecordCaseReportsByPatientRecordCaseId(id)
      .subscribe({
        next: (res) => {
          if (res?.patientRapport === '') {
            this.reportError = this.translate.instant('errorNoAIReport');
          } else {
            this.reportError = '';
            this.displayPdf(res.patientRapport, 'ai');
          }
        },
      });
  }

  toggleShowFullText(event: Event): void {
    event.preventDefault();
    this.showFullText = !this.showFullText;
  }

  toggleShowMedicationFullText(event: Event): void {
    event.preventDefault();
    this.showMedicationFullText = !this.showMedicationFullText;
  }



  setMockData() {
    this.skinAnalysisMetrics = {
      id: 'mock-1',
      patientRecordCaseId: 'mock-case-1',
      fileName: '/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped',
      patientId: 'patient-1',
      patientRecordId: 'record-1',
      customerCode: 'cust-1',
      customerId: 'cust-id-1',
      deviceSerialNo: 'dev-1',
      tdsScore: 3.5,
      tdsClassification: 'Benign',
      isMalignant: false,
      malignantProbability: 0.4035090357065201,
      predictedClass: 'NV',
      success: true,
      createdDate: new Date(),
      updatedDate: null,
      analysis: {
        fileName: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped",
        success: true,
        message: "SUCCESS",
        tdsScore: 3.5,
        tdsClassification: "Benign",
        tdsRiskMessage: "TDS Score: 3.50 - Benign lesion. Regular monitoring recommended.",
        abcdeScores: {
          asymmetry: 0.0,
          border: 0.0,
          color: 3.0,
          diameter: 4.0,
          evolution: 0.0,
          colorsDetected: [
            "Red",
            "LightBrown",
            "DarkBrown"
          ],
          majorAxisPx: 207.17544555664062,
          minorAxisPx: 182.96875
        },
        classification: {
          predictedClass: "NV",
          predictedClassName: "Melanocytic Nevi",
          isMalignant: false,
          malignantProbability: 0.4035090357065201,
          classProbabilities: {
            "AKIEC": 0.13450300693511963,
            "BCC": 0.13450300693511963,
            "BKL": 0.1345030665397644,
            "DF": 0.13450300693511963,
            "MEL": 0.13450302183628082,
            "NV": 0.19298195838928223,
            "VASC": 0.13450300693511963
          }
        },
        visualizations: {
          asymmetryMap: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped.derm.asymmetry.png",
          borderGraph: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped.derm.border.png",
          colorHistogram: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped.derm.color_hist.png",
          diameterGraph: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped.derm.diameter.png",
          gaugeChart: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped.derm.gauge.png",
          lesionOverlay: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped.derm.lesion.space.png",
          cbirComparison: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped.derm.cbir.png",
          maskImage: "/Users/canrollas/Desktop/mask2derm/huid/page5_img1_cropped.derm.mask.png"
        },
        metrics: {
          asymmetry: {
            rotationAngles: [
              0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330
            ],
            rotationScores: [
              0.9251067626999809,
              0.8977501256913022,
              0.8534953661081446,
              0.9358415587745161,
              0.8846033826374586,
              0.8520176622102293,
              0.9289181249201686,
              0.8940600890673023,
              0.8577140748031497,
              0.9446912626360183,
              0.8828407532111235,
              0.854861494994165
            ],
            bestAxisAngle: 270,
            bestAxisScore: 0.9446912626360183,
            worstAxisAngle: 150,
            worstAxisScore: 0.8520176622102293,
            meanScore: 0.8926583881461299,
            stdScore: 0.03286861784459918,
            assessment: "LOW"
          },
          border: {
            segmentAngles: [
              "0°",
              "45°",
              "90°",
              "135°",
              "180°",
              "225°",
              "270°",
              "315°"
            ],
            segmentScores: [
              0.056884497488303376,
              0.05472127298679471,
              0.06777786220660446,
              0.06868135199804522,
              0.11229966024515767,
              0.072536783895121,
              0.07120182783520684,
              0.05506209506507299
            ],
            totalScore: 0.0,
            irregularSegments: 0
          },
          color: {
            colorsDetected: {
              "White": false,
              "Red": true,
              "LightBrown": true,
              "DarkBrown": true,
              "BlueGray": false,
              "Black": false
            },
            colorsCount: 3,
            hueHistogramBins: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170],
            hueHistogramCounts: [11239, 5896, 447, 25, 10, 8, 4, 1, 5, 3, 6, 19, 52, 136, 255, 1220, 2512, 8365]
          },
          diameter: {
            majorAxisPx: 207.17544555664062,
            minorAxisPx: 182.96875,
            aspectRatio: 0.8831584723199128,
            rotationAngle: 98.07711029052734,
            centerX: 197,
            centerY: 270,
            areaPx: 29865.5
          }
        }
      }
    };
  }

  selectAIReportSection(section: 'tdsScoring' | 'asymmetry' | 'borderIrregularity' | 'color' | 'diameter') {
    this.selectedAIReportSection = section;
    this.ch.detectChanges();
    setTimeout(() => {
      this.renderCharts();
    }, 100);
  }

  renderCharts() {
    console.log('renderCharts called. Section:', this.selectedAIReportSection);
    if (!this.skinAnalysisMetrics?.analysis) {
      console.warn('No skinAnalysisMetrics.analysis found');
      return;
    }

    if (this.selectedAIReportSection === 'asymmetry') {
      this.renderAsymmetryChart();
    } else if (this.selectedAIReportSection === 'borderIrregularity') {
      this.renderBorderChart();
    } else if (this.selectedAIReportSection === 'color') {
      this.renderColorChart();
    } else if (this.selectedAIReportSection === 'diameter') {
      this.renderDiameterChart();
    }
  }

  renderAsymmetryChart() {
    console.log('Rendering Asymmetry Chart...');
    const canvas = document.getElementById('asymmetryChart') as HTMLCanvasElement;
    if (!canvas) {
      console.error('Canvas element #asymmetryChart not found');
      return;
    }

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const metrics = this.skinAnalysisMetrics?.analysis?.metrics?.asymmetry;
    console.log('Asymmetry metrics:', metrics);
    if (!metrics?.rotationScores || !metrics?.rotationAngles) {
      console.warn('Missing asymmetry metrics data');
      return;
    }

    // Set canvas parent to full height
    if (canvas.parentElement) {
      canvas.parentElement.style.height = '100%';
      canvas.parentElement.style.display = 'flex';
      canvas.parentElement.style.alignItems = 'center';
      canvas.parentElement.style.justifyContent = 'center';
    }

    // Destroy existing chart if any
    const existingChart = Chart.getChart(canvas);
    if (existingChart) existingChart.destroy();

    new Chart(ctx, {
      type: 'radar',
      data: {
        labels: metrics.rotationAngles.map(a => `${a}°`),
        datasets: [{
          label: 'Asymmetry Score',
          data: metrics.rotationScores,
          backgroundColor: 'rgba(102, 126, 234, 0.2)',
          borderColor: 'rgba(102, 126, 234, 1)',
          borderWidth: 2,
          pointBackgroundColor: 'rgba(102, 126, 234, 1)'
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: { top: 10, bottom: 10, left: 10, right: 10 }
        },
        plugins: {
          legend: { display: false },
          title: {
            display: true,
            text: 'Rotation Scores (0-360°)',
            padding: { top: 5, bottom: 5 },
            font: { size: 11 }
          }
        },
        scales: {
          r: {
            min: 0,
            max: 1,
            grid: { color: 'rgba(0,0,0,0.07)' },
            ticks: { stepSize: 0.2, font: { size: 10 } },
            pointLabels: { font: { size: 10 } }
          }
        }
      }
    });
  }

  renderBorderChart() {
    const canvas = document.getElementById('borderChart') as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const metrics = this.skinAnalysisMetrics?.analysis?.metrics?.border;
    if (!metrics?.segmentScores || !metrics?.segmentAngles) return;

    // Set canvas parent to full height
    if (canvas.parentElement) {
      canvas.parentElement.style.height = '100%';
      canvas.parentElement.style.display = 'flex';
      canvas.parentElement.style.alignItems = 'center';
      canvas.parentElement.style.justifyContent = 'center';
    }

    const existingChart = Chart.getChart(canvas);
    if (existingChart) existingChart.destroy();

    new Chart(ctx, {
      type: 'polarArea',
      data: {
        labels: metrics.segmentAngles,
        datasets: [{
          label: 'Border Irregularity',
          data: metrics.segmentScores,
          backgroundColor: [
            'rgba(255, 107, 107, 0.75)',
            'rgba(255, 107, 107, 0.60)',
            'rgba(255, 142, 83, 0.75)',
            'rgba(255, 142, 83, 0.60)',
            'rgba(255, 107, 107, 0.45)',
            'rgba(255, 142, 83, 0.45)',
            'rgba(255, 107, 107, 0.30)',
            'rgba(255, 142, 83, 0.30)'
          ]
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: { top: 10, bottom: 10, left: 10, right: 10 }
        },
        plugins: {
          legend: {
            position: 'right',
            labels: { font: { size: 9 } }
          },
          title: {
            display: true,
            text: 'Segment Irregularity Scores',
            padding: { top: 5, bottom: 5 },
            font: { size: 11 }
          }
        }
      }
    });
  }

  renderColorChart() {
    const canvas = document.getElementById('colorChart') as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const metrics = this.skinAnalysisMetrics?.analysis?.metrics?.color;
    if (!metrics?.hueHistogramCounts || !metrics?.hueHistogramBins) return;

    // Set canvas parent to full height
    if (canvas.parentElement) {
      canvas.parentElement.style.height = '100%';
      canvas.parentElement.style.display = 'flex';
      canvas.parentElement.style.alignItems = 'center';
      canvas.parentElement.style.justifyContent = 'center';
    }

    const existingChart = Chart.getChart(canvas);
    if (existingChart) existingChart.destroy();

    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: metrics.hueHistogramBins.map(b => b.toString()),
        datasets: [{
          label: 'Hue Count',
          data: metrics.hueHistogramCounts,
          backgroundColor: 'rgba(17, 153, 142, 0.55)',
          borderColor: 'rgba(17, 153, 142, 1)',
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: { top: 10, bottom: 10, left: 10, right: 10 }
        },
        plugins: {
          legend: { display: false },
          title: {
            display: true,
            text: 'Color Hue Histogram',
            padding: { top: 5, bottom: 5 },
            font: { size: 11 }
          }
        },
        scales: {
          x: {
            grid: { color: 'rgba(0,0,0,0.05)' },
            title: { display: true, text: 'Hue Bin', font: { size: 10 } },
            ticks: { font: { size: 9 } }
          },
          y: {
            grid: { color: 'rgba(0,0,0,0.05)' },
            title: { display: true, text: 'Count', font: { size: 10 } },
            ticks: { font: { size: 9 } }
          }
        }
      }
    });
  }

  renderDiameterChart() {
    const canvas = document.getElementById('diameterChart') as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const metrics = this.skinAnalysisMetrics?.analysis?.metrics?.diameter;
    if (!metrics) return;

    const existingChart = Chart.getChart(canvas);
    if (existingChart) existingChart.destroy();

    // Set canvas parent to full height
    if (canvas.parentElement) {
      canvas.parentElement.style.height = '100%';
      canvas.parentElement.style.display = 'flex';
      canvas.parentElement.style.alignItems = 'center';
      canvas.parentElement.style.justifyContent = 'center';
    }

    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['Major axis (mm)', 'Minor axis (mm)', 'Area (mm²)', 'Aspect ratio'],
        datasets: [
          {
            label: 'Diameter metrics',
            data: [
              metrics.majorAxisMm ?? metrics.majorAxisPx ?? 0,
              metrics.minorAxisMm ?? metrics.minorAxisPx ?? 0,
              metrics.areaMm2 ?? metrics.areaPx ?? 0,
              metrics.aspectRatio ?? 0,
            ],
            backgroundColor: [
              'rgba(255, 153, 102, 0.75)',
              'rgba(255, 153, 102, 0.60)',
              'rgba(255, 94, 98, 0.75)',
              'rgba(255, 94, 98, 0.60)',
            ],
            borderColor: [
              'rgba(255, 153, 102, 1)',
              'rgba(255, 153, 102, 1)',
              'rgba(255, 94, 98, 1)',
              'rgba(255, 94, 98, 1)',
            ],
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: { top: 10, bottom: 10, left: 10, right: 10 }
        },
        plugins: {
          legend: { display: false },
          title: {
            display: true,
            text: 'Diameter metrics summary',
            padding: { top: 5, bottom: 5 },
            font: { size: 11 }
          },
        },
        scales: {
          x: {
            grid: { color: 'rgba(0,0,0,0.05)' },
            ticks: { font: { size: 9 } }
          },
          y: {
            beginAtZero: true,
            grid: { color: 'rgba(0,0,0,0.05)' },
            ticks: { font: { size: 9 } }
          },
        },
      },
    });
  }

  activateTab(tabId: string) {
    this.isConsultationReportTabActive = tabId === 'consultationReport';
    if (this.isConsultationReportTabActive) {
      this.getReportWithPatientRecordId();
    }
  }

  getConsultationDetailById(id: string) {
    this.consultationsService
      .consultationDetailByPatientRecordCaseId(id)
      .subscribe({
        next: (res) => {
          this.patientHeaderInformations = res;
          this.statusClass = StatusUtils?.getCaseStatusClass(
            res?.patientStatus
          );
          this.statusText = StatusUtils?.getCaseStatusText(res?.patientStatus);
        },
      });
  }

  getPatientRecordCaseReportsById() {
    if (this.consultationId) {
      this.consultationsService
        .patientRecordCaseReportsByPatientRecordCaseId(this.consultationId)
        .subscribe({
          next: (res) => {
            if (res.patientRapport) {
              this.displayPdf(res.patientRapport, 'ai');
            }
          },
        });
    }
  }

  displayPdf(base64Pdf: string, type: string) {
    if (!base64Pdf) {
      const content = document.getElementById('consultationReport');
      if (content) {
        content.innerHTML = this.translate.instant(
          'notReadyConsultantReportDesc'
        );
      }
      this.ch.detectChanges();
      return;
    }
    const byteCharacters = atob(base64Pdf);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    iframe.src = blobUrl;
    iframe.width = '100%';
    iframe.height = '600px';
    iframe.style.border = 'none';

    let content: HTMLElement | null = null;
    if (type === 'ai') {
      content = document.getElementById('aiReport');
    } else if (type === 'preview') {
      content = document.getElementById('previewFinalReportContent');
    }

    if (content) {
      content.innerHTML = '';
      content.appendChild(iframe);
      iframe.oncancel = () => {
        URL.revokeObjectURL(blobUrl);
      };
    }
  }

  getConsultationTimeLineList(id: string) {
    this.patientsService
      .consultationTimeLineListByPatientRecordCaseId(id)
      .subscribe({
        next: (res) => {
          this.timeLineList = res;
        },
      });
  }

  getDermAiCaseData(caseId: string = this.mobileCaseId) {
    if (!caseId) {
      this.isImagesLoading = false;
      return;
    }

    this.mobileCaseId = caseId;
    this.consultationId = caseId;
    this.isImagesLoading = true;
    const historyItem = this.patientCases?.find(
      (item) => item.patientRecordCaseId === caseId
    );
    if (historyItem?.reviewType === 'AI') {
      this.clearDermoScanLockHeartbeat();
      this.patientsService.getMobilePatientCaseById(caseId).subscribe({
        next: (res) => {
          this.dermAiCase = res;
          this.loadDermAiCase(res);
        },
        error: (error) => {
          this.isImagesLoading = false;
          if (error?.status === 409) {
            this.handleDermoScanLockConflict(error);
          }
        },
      });
      return;
    }
    if (!this.dermoScanLockToken || this.dermoScanLockedCaseId !== caseId) {
      this.dermoScanLockToken = sessionStorage.getItem(`dermoscan-lock-${caseId}`);
      this.dermoScanLockedCaseId = this.dermoScanLockToken ? caseId : null;
    }
    this.acquireDermoScanLock(caseId, () => {
      this.mobileCaseId = caseId;
      this.consultationId = caseId;
      this.patientsService.getMobilePatientCaseById(caseId).subscribe({
        next: (res) => {
          this.dermAiCase = res;
          this.loadDermAiCase(res);
        },
        error: (error) => {
          this.isImagesLoading = false;
          if (error?.status === 409) {
            this.handleDermoScanLockConflict(error);
          }
        },
      });
    });
  }

  private acquireDermoScanLock(
    caseId: string,
    onAcquired: (lockedCaseId: string) => void
  ) {
    if (
      this.dermoScanLockToken &&
      this.dermoScanLockedCaseId === caseId &&
      !this.isReadOnlyDermoScanLock(this.dermoScanLockToken)
    ) {
      this.startDermoScanLockHeartbeat(caseId);
      onAcquired(caseId);
      return;
    }
    this.patientsService.acquireMobilePatientCaseLock(caseId).subscribe({
      next: (lock) => {
        const lockedCaseId = lock?.caseId || caseId;
        const lockToken = lock?.lockToken ?? null;
        this.dermoScanLockToken = this.isReadOnlyDermoScanLock(lockToken)
          ? null
          : lockToken;
        this.dermoScanLockedCaseId = this.dermoScanLockToken ? lockedCaseId : null;
        this.dermoScanLockSubmitted = false;
        if (this.dermoScanLockToken) {
          sessionStorage.setItem(
            `dermoscan-lock-${lockedCaseId}`,
            this.dermoScanLockToken
          );
        }
        this.startDermoScanLockHeartbeat(lockedCaseId);
        onAcquired(lockedCaseId);
      },
      error: (error) => {
        this.isImagesLoading = false;
        this.handleDermoScanLockConflict(error);
      },
    });
  }

  private startDermoScanLockHeartbeat(caseId: string) {
    this.clearDermoScanLockHeartbeat();
    if (this.isReadOnlyDermoScanLock(this.dermoScanLockToken)) return;
    this.dermoScanLockHeartbeat = setInterval(() => {
      if (!this.dermoScanLockToken || this.dermoScanLockSubmitted) return;
      this.patientsService
        .renewMobilePatientCaseLock(caseId, this.dermoScanLockToken)
        .subscribe({ error: () => {} });
    }, 25000);
  }

  private clearDermoScanLockHeartbeat() {
    if (this.dermoScanLockHeartbeat) {
      clearInterval(this.dermoScanLockHeartbeat);
      this.dermoScanLockHeartbeat = null;
    }
  }

  private releaseDermoScanLock() {
    if (this.dermoScanLockSubmitted) return;
    const caseId = this.dermoScanLockedCaseId || this.mobileCaseId;
    const token =
      this.dermoScanLockToken ||
      (caseId ? sessionStorage.getItem(`dermoscan-lock-${caseId}`) : null);
    if (!caseId || !token) return;
    this.dermoScanLockToken = null;
    this.dermoScanLockedCaseId = null;
    sessionStorage.removeItem(`dermoscan-lock-${caseId}`);
    this.patientsService.releaseMobilePatientCaseLock(caseId, token).subscribe({
      error: () => {},
    });
  }

  private markDermoScanLockSubmitted() {
    this.dermoScanLockSubmitted = true;
    this.clearDermoScanLockHeartbeat();
    const lockedCaseId = this.dermoScanLockedCaseId || this.mobileCaseId;
    if (lockedCaseId) {
      sessionStorage.removeItem(`dermoscan-lock-${lockedCaseId}`);
    }
    this.dermoScanLockToken = null;
    this.dermoScanLockedCaseId = null;
  }

  private handleDermoScanLockConflict(error: any) {
    const body = error?.error ?? {};
    const doctorName = body.lockedByDoctorName || body.LockedByDoctorName;
    const message = doctorName
      ? this.translate.instant('dermoscanCaseLockedBy').replace('{name}', doctorName)
      : this.translate.instant('dermoscanCaseLocked');
    this.toastService.showToast(message, 'error');
    this.router.navigate(['/dermoscan/list']);
  }

  private isReadOnlyDermoScanLock(lockToken: string | null | undefined): boolean {
    return !lockToken || lockToken === '00000000-0000-0000-0000-000000000000';
  }

  loadDermAiCase(dermAiCase: any) {
    if (!dermAiCase) {
      this.isImagesLoading = false;
      return;
    }

    this.patientHeaderInformations = {
      ...this.patientHeaderInformations,
      patientId: dermAiCase.patientId,
      name:
        dermAiCase.patientName?.trim() ||
        this.resolvePatientNameFallback(dermAiCase.patientId),
      lastName: dermAiCase.patientLastName?.trim() || '',
      age: dermAiCase.age,
      gender: dermAiCase.gender,
      pidNo: dermAiCase.patientId,
      patientStatus: dermAiCase.caseStatus,
    };
    this.statusClass = StatusUtils?.getCaseStatusClass(dermAiCase.caseStatus);
    this.statusText = StatusUtils?.getCaseStatusText(dermAiCase.caseStatus);

    this.initializeDermAiCases(dermAiCase);

    if (!this.hasResolvedInitialFollowUpCase) {
      this.hasResolvedInitialFollowUpCase = true;
      const followUpCaseId = this.getInitialFollowUpCaseId(dermAiCase);
      if (followUpCaseId && followUpCaseId !== dermAiCase.caseId) {
        this.consultationId = followUpCaseId;
        this.mobileCaseId = followUpCaseId;
        this.router.navigate(
          ['/dermoscan/dermconsultation', followUpCaseId],
          { replaceUrl: true }
        );
        this.getDermAiCaseData(followUpCaseId);
        return;
      }
    }

    this.patientCaseDetails = {
      conclusion: this.resolveConclusionText(dermAiCase),
      email: '',
      phone: '',
      dermatologyCaseInformation: {
        skinType: this.getDermAiSkinTypeValue(dermAiCase.skinType),
        riskFactors: mapToNamedReferences(dermAiCase.medicalHistories),
        dermatologicDiseases: [],
        diseaseCousingImmunosuppressions: [],
        neoplasticDiseases: [],
        otherDiseases: [],
        lesionCharacteristic: dermAiCase.lesionCharacteristic,
      },
      medications: mapToNamedReferences(dermAiCase.medications),
    };
    this.selectedConclusionText = this.resolveConclusionText(dermAiCase);
    this.applyStoredConclusionStructure(dermAiCase.conclusion?.conclusionStructure);
    this.skinAnalysisMetrics = dermAiCase.skinAnalysisMetrics?.analysis
      ? dermAiCase.skinAnalysisMetrics
      : this.buildSkinAnalysisMetricsFromResult(dermAiCase);
    this.isAiLoading = false;

    this.loadDermAiCaseImages(dermAiCase);
    this.setSelectedConclusionOptions();
  }

  private buildSkinAnalysisMetricsFromResult(
    dermAiCase: DermAiCaseListModel
  ): SkinAnalysisMetricsModel | null {
    if (!dermAiCase?.analysisResult) {
      return null;
    }

    try {
      let analysis: any =
        typeof dermAiCase.analysisResult === 'string'
          ? JSON.parse(dermAiCase.analysisResult)
          : dermAiCase.analysisResult;

      if (typeof analysis === 'string') {
        analysis = JSON.parse(analysis);
      }

      analysis = analysis?.analysis ?? analysis?.result ?? analysis;
      if (!analysis || typeof analysis !== 'object') {
        return null;
      }

      return {
        id: `dermai-${dermAiCase.caseId}`,
        patientRecordCaseId: dermAiCase.caseId,
        fileName: dermAiCase.photoOne ?? analysis.fileName ?? '',
        patientId: dermAiCase.patientId,
        patientRecordId: '',
        customerCode: 'DERMAI',
        customerId: 'DERMAI',
        deviceSerialNo: 'DERMAI',
        tdsScore: analysis.tdsScore ?? 0,
        tdsClassification: analysis.tdsClassification ?? '',
        isMalignant: analysis.classification?.isMalignant ?? false,
        malignantProbability:
          analysis.classification?.malignantProbability ?? 0,
        predictedClass: analysis.classification?.predictedClass ?? '',
        success: analysis.success ?? false,
        analysis,
        createdDate: new Date(dermAiCase.createdDate),
        updatedDate: null,
      };
    } catch {
      return null;
    }
  }

  private initializeDermAiCases(dermAiCase: DermAiCaseListModel) {
    const history = dermAiCase.followUpHistory ?? [];
    if (history.length) {
      this.patientCases = [...history]
        .sort(
          (left, right) =>
            new Date(left.createdAt).getTime() -
            new Date(right.createdAt).getTime()
        )
        .map((item, index) => this.toPatientCaseFromHistory(item, index));
    } else if (!this.patientCases?.length) {
      const relatedCases: Array<DermAiCaseListModel | DermAiRelatedCaseModel> =
        dermAiCase.parentCase
          ? [
              dermAiCase.parentCase,
              dermAiCase,
              ...(dermAiCase.followUps ?? []),
            ]
          : [dermAiCase, ...(dermAiCase.followUps ?? [])];

      const uniqueCases = relatedCases.filter(
        (item, index, items) =>
          items.findIndex((candidate) => candidate.caseId === item.caseId) ===
          index
      );

      this.patientCases = uniqueCases
        .sort(
          (left, right) =>
            new Date(left.createdDate).getTime() -
            new Date(right.createdDate).getTime()
        )
        .map((item, index) => this.toPatientCase(item, index));
    } else {
      const existingCase = this.patientCases.find(
        (item) => item.patientRecordCaseId === dermAiCase.caseId
      );
      if (existingCase) {
        existingCase.isCaseCompleted = this.isHistoryItemCompleted(
          dermAiCase.isDermatologistReview,
          dermAiCase.caseStatus
        );
        existingCase.isRecordCompleted = existingCase.isCaseCompleted
          ? 'true'
          : '';
      }
    }

    this.activeCase =
      this.patientCases.find(
        (item) => item.patientRecordCaseId === dermAiCase.caseId
      ) ?? this.patientCases[0];
  }

  private getInitialFollowUpCaseId(dermAiCase: DermAiCaseListModel): string | null {
    const hasConclusion = !!dermAiCase.conclusion?.conclusion?.trim();
    if (hasConclusion) {
      return null;
    }

    const current = this.patientCases?.find(
      (item) => item.patientRecordCaseId === dermAiCase.caseId
    );
    const isPendingDermatologist =
      current?.reviewType === 'Dermatologist' && !current.isCaseCompleted;
    if (isPendingDermatologist) {
      return null;
    }

    const latestCompletedReview = [...(this.patientCases ?? [])]
      .filter(
        (item) => item.reviewType === 'Dermatologist' && item.isCaseCompleted
      )
      .pop();

    return latestCompletedReview?.patientRecordCaseId ?? null;
  }

  private resolveConclusionText(dermAiCase: DermAiCaseListModel): string {
    const fromApi = dermAiCase.conclusion?.conclusion?.trim() ?? '';
    if (fromApi) {
      return dermAiCase.conclusion?.conclusion ?? fromApi;
    }

    const isPendingDermatologist =
      this.activeCase?.reviewType === 'Dermatologist' &&
      !this.activeCase?.isCaseCompleted;
    if (isPendingDermatologist) {
      return '';
    }

    return (
      [...(this.patientCases ?? [])]
        .filter(
          (item) => item.reviewType === 'Dermatologist' && !!item.diagnosis
        )
        .pop()?.diagnosis ?? ''
    );
  }

  private toPatientCaseFromHistory(
    item: DermAiFollowUpHistoryItem,
    index: number
  ): PatientCaseModel {
    const isDermatologist = item.type !== 'AI';
    const completed = this.isHistoryItemCompleted(
      isDermatologist,
      item.caseStatus
    );
    return {
      patientRecordCaseId: item.id,
      patientRecordCaseNumber: String(index + 1),
      isCaseCompleted: completed,
      isRecordCompleted: completed ? 'true' : '',
      reviewType: isDermatologist ? 'Dermatologist' : 'AI',
      riskLevel: item.riskLevel,
      recommendation: item.recommendation,
      tdsScore: item.tdsScore,
      diagnosis: item.diagnosis,
      thumbnailImage: item.thumbnailImage,
      createdAt: item.createdAt,
      relatedCaseId: item.relatedCaseId,
      statusName: item.status,
      reviewingDoctorName: item.reviewingDoctorName,
    };
  }

  private isHistoryItemCompleted(
    isDermatologist: boolean,
    caseStatus: number
  ): boolean {
    return isDermatologist ? caseStatus === 4 : caseStatus === 2 || caseStatus === 4;
  }

  private toPatientCase(
    item: DermAiCaseListModel | DermAiRelatedCaseModel,
    index: number
  ): PatientCaseModel {
    const isDermatologist =
      'isDermatologistReview' in item ? !!item.isDermatologistReview : true;
    const completed = this.isHistoryItemCompleted(isDermatologist, item.caseStatus);
    return {
      patientRecordCaseId: item.caseId,
      patientRecordCaseNumber: String(index + 1),
      isCaseCompleted: completed,
      isRecordCompleted: completed ? 'true' : '',
      reviewType: isDermatologist ? 'Dermatologist' : 'AI',
      reviewingDoctorName:
        'reviewingDoctorName' in item ? item.reviewingDoctorName : undefined,
    };
  }

  private resolvePatientNameFallback(patientId?: string): string {
    return patientId?.trim() || '-';
  }

  private getDermAiSkinTypeValue(skinType?: string): number | null {
    const skinTypeOrder = [
      'Pale',
      'Sensitive',
      'Fair',
      'Olive',
      'Dark',
      'VeryDark',
    ];
    const index = skinType ? skinTypeOrder.indexOf(skinType) : -1;
    return index >= 0 ? index + 1 : null;
  }

  loadDermAiCaseImages(dermAiCase: any) {
    const generation = ++this.caseImageLoadGeneration;
    this.revokeCaseImageObjectUrls();
    this.patientRecordCaseImages = [];

    const imageTypes: Array<'one' | 'two'> = [];
    if (dermAiCase?.hasPhotoOne) imageTypes.push('one');
    if (dermAiCase?.hasPhotoTwo) imageTypes.push('two');

    if (!imageTypes.length) {
      this.isImagesLoading = false;
      return;
    }

    const caseId = dermAiCase.caseId || this.mobileCaseId;
    this.isImagesLoading = true;

    this.patientRecordCaseImages = imageTypes.map((type, index) => ({
      src: null,
      id: `imageModal${index + 1}`,
      alt: `Lesion Close-up ${index + 1}`,
      patientRecordId: caseId,
      imageId: `${caseId}-${type}`,
      isSelected: index === 0,
      isReportImage: index === 0,
    }));

    let pending = imageTypes.length;
    imageTypes.forEach((type, index) => {
      this.patientsService.getMobilePatientCaseImage(caseId, type).subscribe({
        next: (blob) => {
          const objectUrl = URL.createObjectURL(blob);
          if (generation !== this.caseImageLoadGeneration) {
            URL.revokeObjectURL(objectUrl);
            return;
          }

          this.caseImageObjectUrls.push(objectUrl);
          this.patientRecordCaseImages[index].src = objectUrl;

          if (index === 0) {
            this.currentCaseData = {
              src: objectUrl,
              isSelected: this.patientRecordCaseImages[index].isSelected,
              isReportImage: this.patientRecordCaseImages[index].isReportImage,
              imageId: this.patientRecordCaseImages[index].imageId,
              patientRecordCaseId: caseId,
            };
          }

          this.ch.detectChanges();
        },
        complete: () => {
          if (generation !== this.caseImageLoadGeneration) {
            return;
          }
          pending--;
          if (pending <= 0) {
            this.isImagesLoading = false;
          }
        },
        error: () => {
          if (generation !== this.caseImageLoadGeneration) {
            return;
          }
          pending--;
          if (pending <= 0) {
            this.isImagesLoading = false;
          }
        },
      });
    });
  }

  getConclusionOptions() {
    this.consultationsService.conclusionOptions().subscribe({
      next: (res) => {
        this.conclusionOptions = res;
        if (this.activeCase) {
          const conclusion = this.selectedConclusionText;
          this.setSelectedConclusionOptions();
          this.selectedConclusionText = conclusion;
        }
      },
    });
  }

  getConclusions(patientRecordCaseId: string) {
    this.consultationsService.conclusions(patientRecordCaseId).subscribe({
      next: (res: any) => {
        if (res?.skinConditionConclusionList?.length) {
          const conclusion = res.skinConditionConclusionList.find(
            (item) => item.patientRecordCaseId === patientRecordCaseId
          );

          this.selectedDiagnosis = conclusion.diagnoseTypeCategoryId;
          this.onDiagnosisChange();
          this.selectedSubcategory = conclusion.diagnoseTypeContentId;
          this.selectedConclusionText =
            conclusion.diagnoseTypeContentDescription;
        } else if (res?.malignantMelanomaTypeConclusionList?.length) {
          this.selectedDiagnosis = MALIGNANT_SKIN_CONDITIONS;
        }
      },
    });
  }

  getDiagnoseTypeCategoryList() {
    this.consultationsService.diagnoseTypeCategoryList().subscribe({
      next: (res) => {
        this.diagnoses = res;
      },
    });
  }

  async getCasesByRecordId() {
    this.patientCases = await this.consultationsService.getCasesByRecordId(
      this.patientRecordId
    );
  }

  activeCaseChange(item: PatientCaseModel) {
    this.activeCase = item;
    this.consultationId = item.patientRecordCaseId;
    this.mobileCaseId = item.patientRecordCaseId;
    this.initAfterActiveCaseChange();
  }

  getType(item: ConclusioOptions) {
    if (item.id === COLOR_OPTION_ID)
      return item.title[0].toLowerCase() + item.title.slice(1);
    else if (item.id === BORDER_OPTION_ID)
      return item.title[0].toLowerCase() + item.title.slice(1);
    else return '';
  }

  setSelectedConclusionOptions() {
    let selectedTexts: string[] = [];
    let storedDataDeleted = false;
    const caseKey = `selectedConclusionOptions_${this.activeCase?.patientRecordCaseId}`;
    const storedData = localStorage.getItem(caseKey);

    if (storedData && this.activeCase?.isCaseCompleted) {
      localStorage.removeItem(caseKey);
      storedDataDeleted = true;

      let activeKeys = JSON.parse(
        localStorage.getItem('activeCaseIdKeys') || '[]'
      );
      activeKeys = activeKeys.filter((key) => key !== caseKey);
      localStorage.setItem('activeCaseIdKeys', JSON.stringify(activeKeys));
    }

    if (
      storedData &&
      !storedDataDeleted &&
      JSON.parse(storedData).activeCaseId ===
      this.activeCase?.patientRecordCaseId &&
      JSON.parse(storedData).editUser === this.currentUser.id
    ) {
      const consultationOptions =
        JSON.parse(storedData)?.consultationOptions || [];
      this.selectedConclusionOptions = [...consultationOptions];
      this.setSelectedConsultationText();

      selectedTexts = this.getCleanSelectedConclusionArray();

      if (!this.selectedConclusionOptions?.length) {
        this.selectedConclusionOptions = [];
        for (const item of this.conclusionOptions) {
          const newConclusionOption: SelectedConclusionModel = {
            optionId: item.id,
            conclusionTextId: '',
            conclusionText: '',
            type: this.getType(item),
          };
          this.selectedConclusionOptions.push(newConclusionOption);
        }
      }
    } else {
      if (!this.conclusionOptions?.length) return;

      selectedTexts = this.getCleanSelectedConclusionArray();

      if (!this.selectedConclusionOptions?.length) {
        this.selectedConclusionOptions = [];
        for (const item of this.conclusionOptions) {
          const newConclusionOption: SelectedConclusionModel = {
            optionId: item.id,
            conclusionTextId: '',
            conclusionText: '',
            type: this.getType(item),
          };
          this.selectedConclusionOptions.push(newConclusionOption);
        }
      }
    }
    this.selectedConclusionOptions.forEach((item, i) => {
      const selectedItem = this.conclusionOptions[
        i
      ].conclusionOptionContents.find((x) =>
        selectedTexts.some((y) => x.conclusionText.includes(y))
      );
      if (selectedItem?.conclusionText) {
        item.conclusionText = selectedItem.conclusionText;
        item.conclusionTextId = selectedItem.id;
      }
    });

    setTimeout(() => {
      this.showDisableButtonDesc = true;
    }, 2000);
  }

  getCleanSelectedConclusionArray(): string[] {
    const selectedTexts = this.selectedConclusionText.split('.');
    return selectedTexts
      .map((item) => item.replace(/[\r\n]/g, ''))
      .filter((item) => item.trim() !== '');
  }

  updateConclusionOutput(event: Event, conclusionId?: string): void {
    let selectedId: string = '';

    if (conclusionId) {
      selectedId = conclusionId;
      return;
    } else {
      selectedId = (event.target as HTMLSelectElement).value;
    }
    this.selectedOption = this.conclusionOptions
      .flatMap((option: any) => option.conclusionOptionContents)
      .find((item: any) => item.id === selectedId);

    //console.log("conclusionOptions: ", this.conclusionOptions)

    //console.log("selectedOption: ", this.selectedOption)

    const selectedOptionId = this.selectedOption?.conclusionOptionId;
    let selectedText = this.selectedOption?.conclusionText || '';
    const consultationOption = this.selectedConclusionOptions.find(
      (x) => x.optionId === selectedOptionId
    );
    consultationOption.conclusionText = selectedText;
    consultationOption.conclusionTextId = selectedId;

    const selectedOptionData = {
      caseId: this.activeCase.patientRecordCaseId,
      optionId: selectedOptionId,
      conclusionText: selectedText,
      conclusionTextId: selectedId,
    };

    //console.log("selectedOptionData ", selectedOptionData)
    const existingIndex = this.selectedOptionsArray.findIndex(
      (item) =>
        item.caseId === this.activeCase.patientRecordCaseId &&
        item.optionId === selectedOptionId
    );

    if (existingIndex !== -1) {
      this.selectedOptionsArray[existingIndex] = selectedOptionData;
    } else {
      this.selectedOptionsArray.push(selectedOptionData);
    }

    this.selectedOptionsArray = [...new Set(this.selectedOptionsArray)];
    const formattedData = {
      editUser: this.currentUser.id,
      activeCaseId: this.activeCase.patientRecordCaseId,
      consultationOptions: this.selectedConclusionOptions,
    };

    const keyListKey = 'activeCaseIdKeys';
    let activeKeys = JSON.parse(localStorage.getItem(keyListKey) || '[]');
    const newKey = `selectedConclusionOptions_${this.activeCase.patientRecordCaseId}`;

    if (!activeKeys.includes(newKey)) {
      if (activeKeys.length >= 10) {
        const oldestKey = activeKeys.shift();
        if (oldestKey) {
          localStorage.removeItem(oldestKey);
        }
      }
      activeKeys.push(newKey);
    }
    localStorage.setItem(keyListKey, JSON.stringify(activeKeys));

    localStorage.setItem(newKey, JSON.stringify(formattedData));

    this.setSelectedConsultationText();
  }

  isAdvancedExaminaitonSelected() {
    return this.selectedOptionsArray.some(
      (item) => item.conclusionTextId === ADVANCED_EXAMINATION
    ) || (this.recommendationOption && this.recommendationOption.conclusionTextId === ADVANCED_EXAMINATION)
      ;
  }

  getAnnotationText(item) {
    if (
      !(
        item.optionId === BORDER_OPTION_ID || item.optionId === COLOR_OPTION_ID
      ) ||
      !this.annotationList?.length ||
      !item.conclusionText
    )
      return '';

    const irregularStreaksPseudopodsId = IRREGULAR_STREAKS_PSEUDOPODS_ID;

    if (item.optionId === COLOR_OPTION_ID) {
      const otherConclusions = this.annotationList.filter(
        (ann) => ann.annotationId !== irregularStreaksPseudopodsId
      );
      const uniqueDescriptions = new Set();

      this.drawnRects.forEach((rect) => {
        const anotation = otherConclusions.find(
          (ann) => ann.annotationId === rect.selectedAnnotationId
        );
        if (rect.selectedAnnotationId === anotation?.annotationId) {
          uniqueDescriptions.add(anotation.annotationDescription);
        }
      });

      return ' ' + Array.from(uniqueDescriptions).join(' ');
    }

    if (item.optionId === BORDER_OPTION_ID) {
      const irregularStreaksPseudopods = this.annotationList.find(
        (ann) => ann.annotationId === irregularStreaksPseudopodsId
      );
      const uniqueDescriptions = new Set();

      this.drawnRects.forEach((rect) => {
        const anotation = irregularStreaksPseudopods;
        if (rect.selectedAnnotationId === anotation?.annotationId) {
          uniqueDescriptions.add(anotation.annotationDescription);
        }
      });

      return ' ' + Array.from(uniqueDescriptions).join(' ');
    }

    return '';
  }

  setSelectedConsultationText() {
    if (this.selectedDiagnosis === this.malignantSkinConditions) {
      const resultText = this.selectedConclusionOptions
        .map(
          (item) => item.conclusionText.trim() + this.getAnnotationText(item)
        )
        .filter((text) => text !== '')
        .join('\r');
      console.log("resultText ", resultText)
      this.selectedConclusionText = resultText;
    }
  }

  private applyStoredConclusionStructure(structure?: {
    diagnosisCategoryId?: string;
    diagnoseTypeContentId?: string;
    conclusionOptionInfos?: {
      conclusionOptionId: string;
      conclusionOptionContentId: string;
      annotations?: { annotationId: string }[];
    }[];
    isLegacyTextOnly?: boolean;
  } | null) {
    if (!structure || structure.isLegacyTextOnly) {
      return;
    }

    if (structure.diagnosisCategoryId) {
      this.selectedDiagnosis = structure.diagnosisCategoryId;
      this.onDiagnosisChange();
    }

    if (structure.diagnoseTypeContentId) {
      this.selectedSubcategory = structure.diagnoseTypeContentId;
      if (structure.diagnosisCategoryId === this.benignSkinConditions) {
        this.onSubcategoryChange('benign');
      } else if (
        structure.diagnosisCategoryId === this.preMalignantSkinConditions
      ) {
        this.onSubcategoryChange('preMalignant');
      } else if (
        structure.diagnosisCategoryId === this.malignantSkinConditions
      ) {
        this.onSubcategoryChange('malignant');
      }
    }
  }

  private buildMobileConclusionPayload(caseId: string) {
    // DermoScan mobile shows free-text when isLegacyTextOnly is true.
    // Structured diagnosis IDs would hide this custom conclusion on the app.
    const conclusion = (this.selectedConclusionText ?? '').trim();

    return {
      caseId,
      conclusion,
      conclusionStructure: {
        conclusionOptionInfos: [],
        isLegacyTextOnly: true,
      },
      isLegacyTextOnly: true,
    };
  }

  isSelectedOption(consultationText: string) {
    return this.selectedConclusionOptions.some(
      (x) => x.conclusionText === consultationText
    );
  }

  isSelectDisable(option: ConclusioOptions) {
    if (
      this.currentUser?.role === this.userRole.OrganizationAdmin ||
      this.currentUser?.role === this.userRole.GeneralPractitioner
    )
      return true;
    if (this.activeCase?.isRecordCompleted) return true;
    if (!this.selectedConclusionOptions?.length) return false;
    const isLastOption =
      option.id ===
      this.selectedConclusionOptions[this.selectedConclusionOptions.length - 1]
        .optionId;
    const hasEmptyOptions = this.selectedConclusionOptions.filter(
      (x) => x.conclusionText == ''
    );
    if (isLastOption && hasEmptyOptions?.length > 1) return true;
    return false;
  }

  isSubmitButtonDisable() {
    if (this.isAiHistoryCase()) return true;
    if (this.dermAiCase?.conclusion) return true;
    if (this.currentUser?.role === this.userRole.OrganizationAdmin) return true;
    // DermoScan receives free-text conclusion; require non-empty text.
    return !(this.selectedConclusionText ?? '').trim().length;
  }

  isPreviewButtonDisable() {
    return this.isSubmitButtonDisable();
  }

  isAiHistoryCase(): boolean {
    return this.activeCase?.reviewType === 'AI' || this.dermAiCase?.reviewType === 'AI';
  }

  isConclusionReadOnly(): boolean {
    return (
      this.isAllCasesCompleted() ||
      this.isAiHistoryCase() ||
      !!this.activeCase?.isCaseCompleted
    );
  }

  isAllCasesCompleted() {
    const dermatologistCases = (this.patientCases ?? []).filter(
      (x) => x.reviewType !== 'AI'
    );
    if (!dermatologistCases.length) {
      const hasUncompletedCase = this.patientCases?.some(
        (x) => x.isCaseCompleted == false
      );
      if (hasUncompletedCase) return false;
      return true;
    }
    return dermatologistCases.every((x) => x.isCaseCompleted);
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = '/assets/media/not-found.jpeg';
  }

  async previewReport() {
    this.previewReportErrorText = '';

    setTimeout(() => {
      const content = document.getElementById('previewFinalReportContent');
      if (!content) return;

      const title = document.createElement('h4');
      title.textContent = this.translate.instant('previewFinalReport');

      const patient = document.createElement('p');
      patient.textContent = `${this.translate.instant('patientId')}: ${
        this.patientHeaderInformations?.patientId ?? '-'
      }`;

      const caseId = document.createElement('p');
      caseId.textContent = `${this.translate.instant('caseId')}: ${
        this.mobileCaseId
      }`;

      const conclusion = document.createElement('p');
      conclusion.textContent = this.selectedConclusionText || '-';

      content.replaceChildren(title, patient, caseId, conclusion);
    });
  }

  checkResultConsultationReport() {
    this.consultationsService
      .checkConsultationReport(this.patientRecordId)
      .subscribe({
        next: (res) => {
          if (!res) {
            setTimeout(() => {
              this.checkResultConsultationReport();
            }, 2000);
            this.previewReportErrorText = this.translate.instant(
              'notReadyPreviewReportDesc'
            );
          } else {
            this.previewReportErrorText = null;
            this.getReportWithPatientRecordId();
          }
        },
      });
  }

  startCheckConsultationReport() {
    const checkInterval = 2000;

    this.subscription = interval(checkInterval)
      .pipe(
        switchMap(() => this.checkConsultationReport(this.patientRecordId)),
        takeWhile(
          (isConsultationReportGenerated) => !isConsultationReportGenerated,
          true
        )
      )
      .subscribe({
        next: (isConsultationReportGenerated) => {
          if (isConsultationReportGenerated) {
            this.getReportWithPatientRecordId();
            this.subscription.unsubscribe();
          } else {
            this.previewReportErrorText = this.translate.instant(
              'notReadyPreviewReportDesc'
            );
          }
        },
        error: () => {
          this.subscription.unsubscribe();
        },
      });
  }

  checkConsultationReport(patientRecordId: string): Observable<boolean> {
    return this.consultationsService
      .checkConsultationReport(patientRecordId)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(() => {
          return of(false);
        })
      );
  }

  preventForbiddenCharacters(
    event: Event,
    type: 'number' | 'text' | 'email' | 'tel'
  ): void {
    this.inputValidationService.preventForbiddenCharacters(event, type);
  }

  // DermoScan: chat disabled
  // downloadChatFile(path: string, fileName: string) {
  //   const base64Data = path.includes(',') ? path.split(',')[1] : path;

  //   const binaryString = window.atob(base64Data);
  //   const len = binaryString.length;
  //   const bytes = new Uint8Array(len);

  //   for (let i = 0; i < len; i++) {
  //     bytes[i] = binaryString.charCodeAt(i);
  //   }

  //   const blob = new Blob([bytes], { type: 'application/octet-stream' });
  //   const url = window.URL.createObjectURL(blob);

  //   const a = document.createElement('a');
  //   document.body.appendChild(a);
  //   a.style.display = 'none';
  //   a.href = url;
  //   a.download = fileName;
  //   a.click();

  //   document.body.removeChild(a);
  //   window.URL.revokeObjectURL(url);
  // }

  async getConsultationMailTemplateAsync() {
    const templateResponse =
      await this.consultationsService.getConsultationReportTemplate();

    this.notificationMailTemplate = this.consultationsService
      .getConsultationReportTemplateById(
        this.consultationId,
        templateResponse.body
      )
      .subscribe((res) => {
        this.notificationMailTemplate = res;
      });
  }

  async getUserNotificationSettings() {
    const userNotificationSettings = await this.usersService
      .getUserNotificationSettings(
        this.patientHeaderInformations?.generalPractitionerUserName ?? ''
      )
      .toPromise();
    return userNotificationSettings;
  }

  // DermoScan: Send Report submits the conclusion to the mobile patient case
  // instead of the standard consultation report flow.
  async sendReport() {
    const caseId =
      this.activeCase?.patientRecordCaseId || this.mobileCaseId;

    if (!caseId) {
      this.toastService.showToast(
        this.translate.instant('errorSendReportDesc'),
        'error'
      );
      return;
    }

    this.patientsService
      .submitMobilePatientCaseConclusion(
        this.buildMobileConclusionPayload(caseId)
      )
      .subscribe({
        next: () => {
          this.markDermoScanLockSubmitted();
          this.toastService.showToast(
            this.translate.instant('successSendReportDesc'),
            'success'
          );

          this.isOverlayLoading = true;

          setTimeout(() => {
            const caseKey = `selectedConclusionOptions_${this.activeCase?.patientRecordCaseId}`;
            localStorage.removeItem(caseKey);
            this.router.navigate(['/dermoscan/list']);
          }, 1000);
        },
        error: (error) => {
          if (error?.status === 409) {
            this.handleDermoScanLockConflict(error);
            return;
          }
          this.toastService.showToast(
            this.translate.instant('errorSendReportDesc'),
            'error'
          );
        },
      });
  }

  getReportWithPatientRecordId() {
    this.consultationsService
      .getReportWithPatientRecordId(this.patientRecordId)
      .subscribe({
        next: (res) => {
          if (res?.patientRapport) {
            this.displayPdf(res.patientRapport, 'preview');
          }
        },
      });
  }

  showCaseDetails(index: number, selectItem: any): void {
    if (selectItem.patientRecordCaseId || selectItem.patientRecordId) {
      this.patientRecordCaseImages = [];
      this.isImagesLoading = true;
      this.selectedIndex = index;
      this.getPatientInformationsAndLocation(selectItem.patientRecordCaseId);
      this.getPatientCaseDetail(selectItem.patientRecordCaseId);
      this.getPatientRecordCaseImagesById(selectItem.patientRecordCaseId);
    }
  }

  getPatientInformationsAndLocation(id: string) {
    this.consultationsService
      .consultationDetailByPatientRecordCaseId(id)
      .subscribe({
        next: (res) => {
          if (res) {
            this.patientHeaderInformations = res;
          }
        },
      });
  }

  async getPatientCaseDetail(id: string) {
    this.patientsService.patientRecordCaseDetail(id).subscribe({
      next: async (res) => {
        if (res) {
          this.patientCaseDetails = res;
          if (res.conclusion) {
            this.selectedConclusionText = res.conclusion;
          }
          this.setSelectedConclusionOptions();
          this.getConsultationDetailById(this.consultationId);
          this.getPatientRecordCaseImagesById(this.consultationId);
          this.getSelectedImage();
          this.getConsultationTimeLineList(this.consultationId);
          this.getPatientConsultationImageHistory(this.consultationId);
          await this.getAiImages();
          this.getSkinAnalysisMetrics(this.consultationId);
          // DermoScan: chat disabled
          // this.getChatList(this.consultationId);
          this.getConclusions(this.consultationId);
          await this.getUserNotificationSettings();
        }
      },
    });
  }

  getSkinAnalysisMetrics(id: string) {
    const patientRecordCaseId = this.activeCase?.patientRecordCaseId || id;

    if (!patientRecordCaseId) {
      return;
    }

    this.consultationsService.getSkinAnalysisMetrics(patientRecordCaseId).subscribe({
      next: (res) => {
        // If backend doesn't have metrics yet, keep the mock data (or previous data)
        const hasBackendMetrics = !!res?.analysis?.metrics;
        if (hasBackendMetrics) {
          this.skinAnalysisMetrics = res;
          this.ch.detectChanges();
        } else if (!this.skinAnalysisMetrics?.analysis?.metrics) {
          // nothing meaningful currently loaded; keep null-ish backend response
          this.skinAnalysisMetrics = res;
        }
      },
      error: (err) => {
        console.error('Error fetching skin analysis metrics:', err);
        if (this.activeRightTab === '#aiReport') {
          this.ch.detectChanges();
        }
      }
    });
  }

  getPatientRecordCaseImagesById(id: string) {
    this.isImagesLoading = true;
    this.revokeCaseImageObjectUrls();
    this.consultationsService.patientRecordImagesByPatientId(id).subscribe({
      next: (res) => {
        if (res.length > 0) {
          this.patientRecordCaseImages = res.map(
            (image: any, index: number) => ({
              src: this.resolveCaseImageSrc(image),
              id: `imageModal${index + 1}`,
              alt: `Lesion Close-up ${index + 1}`,
              patientRecordId: image.patientRecordCaseId,
              imageId: image.id,
              isSelected: image.isSelected,
              isReportImage: image.isReportImage,
            })
          );
          this.loadMissingCaseImages(res);
          this.getReportedCaseImages(this.consultationId);
        }
        this.isImagesLoading = false;
      },
      error: () => {
        this.isImagesLoading = false;
      },
    });
  }

  resolveCaseImageSrc(image: any): string | null {
    if (image?.fileData?.length) {
      return `data:image/jpeg;base64,${image.fileData}`;
    }

    const folderPath = image?.folderPath;
    if (!folderPath || typeof folderPath !== 'string') {
      return null;
    }

    if (folderPath.startsWith('http://') || folderPath.startsWith('https://')) {
      return folderPath;
    }

    return null;
  }

  loadMissingCaseImages(images: any[]) {
    images.forEach((image: any, index: number) => {
      if (this.patientRecordCaseImages[index]?.src || !image?.id) {
        return;
      }

      this.consultationsService.patientRecordCaseImageFile(image.id).subscribe({
        next: (blob) => {
          const objectUrl = URL.createObjectURL(blob);
          this.caseImageObjectUrls.push(objectUrl);
          this.patientRecordCaseImages[index].src = objectUrl;

          if (this.currentCaseData.imageId === image.id) {
            this.currentCaseData.src = objectUrl;
          }

          this.ch.detectChanges();
        },
        error: () => { },
      });
    });
  }

  private revokeCaseImageObjectUrls() {
    this.caseImageObjectUrls.forEach((url) => URL.revokeObjectURL(url));
    this.caseImageObjectUrls = [];
  }

  getPatientConsultationImageHistory(id: string) {
    this.patientsService.patientRecordCaseImagesHistory(id).subscribe({
      next: (res) => {
        if (res.length > 0) {
          this.patientHistoryImages = res.map((element: any) => ({
            createdDate: element.createdDate,
            images: element.images.map((imageItem: any) => ({
              src: `data:image/jpeg;base64,${imageItem.fileData}`,
              patientRecordCaseId: imageItem.patientRecordCaseId,
              imageId: imageItem.imageId,
              isReportImage: imageItem.isReportImage,
              isSelected: imageItem.isSelected,
            })),
          }));

          this.getReportedCaseImages(this.consultationId);
        }
      },
    });
  }

  getReportedCaseImages(id: string) {
    this.patientsService.patientReportCaseImages(id).subscribe({
      next: (res) => {
        if (res) {
          this.patientCaseReportImages = {
            patientRecordCaseId: res.patientRecordCaseId,
            currentCaseImageId: res.currentCaseImageId,
            historyCaseImageId: res.historyCaseImageId,
          };
          this.updateCurrentCaseImageDataAsReportedImages();
          this.updateHistoryCaseImageDataAsReportedImages();
        }
      },
    });
  }

  updateCurrentCaseImageDataAsReportedImages() {
    var data = this.patientRecordCaseImages.find(
      (x) => x.imageId == this.patientCaseReportImages.currentCaseImageId
    );
    var index = this.patientRecordCaseImages.findIndex(
      (x) => x.imageId == this.patientCaseReportImages.currentCaseImageId
    );
    if (data != null) {
      data.isReportImage = true;
    }

    this.updateCurrentCaseData(index > 0 ? index : 0);
  }

  updateHistoryCaseImageDataAsReportedImages() {
    this.patientHistoryImages.forEach((historyGroup, historyGroupIndex) => {
      const targetImage = historyGroup.images.find(
        (image) =>
          image.imageId === this.patientCaseReportImages.historyCaseImageId
      );

      if (targetImage) {
        targetImage.isReportImage = true;
        //this.updateHistoryCaseData(historyGroupIndex);
      }
    });
  }

  getStatusClass(status: number): string {
    return StatusUtils?.getCaseStatusClass(status);
  }

  getStatusText(status: number): string {
    return StatusUtils?.getCaseStatusText(status);
  }

  updateContent(images: string[], item: any, pivot: string) {
    this.selectedItem = item;
  }

  // DermoScan: chat disabled
  // handleFileClick(event: MouseEvent): void {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   this.fileInput.nativeElement.click();
  // }

  // handleFileUpload(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   if (input.files && input.files.length > 0) {
  //     this.fileCount = input.files.length;
  //     this.file = input.files[0];
  //     input.value = '';
  //   }
  // }

  // getChatList(id: string) {
  //   if (!id) return;
  //   this.chatService.chatList(id).subscribe({
  //     next: (res) => {
  //       if (res) {
  //         this.chatList = res;
  //         this.scrollToBottom();
  //         this.getUserAvatars();
  //         this.getOtherUserName();
  //       }
  //     },
  //   });
  // }

  // getUserAvatars() {
  //   const userIds = this.chatList?.map((item) => item.createdUserId);

  //   const formData = {
  //     userIds,
  //   };

  //   this.chatService.userAvatars(formData).subscribe({
  //     next: (res) => {
  //       this.currentUserAvatar = res?.find(
  //         (item) => item.userId === this.currentUser?.id
  //       )?.avatarImage
  //         ? `data:image/jpeg;base64,${res.find((item) => item.userId === this.currentUser?.id)
  //           ?.avatarImage
  //         }`
  //         : 'assets/media/profile/profile-picture.png';

  //       this.otherUserAvatar = res?.find(
  //         (item) => item.userId !== this.currentUser?.id
  //       )?.avatarImage
  //         ? `data:image/jpeg;base64,${res.find((item) => item.userId !== this.currentUser?.id)
  //           ?.avatarImage
  //         }`
  //         : 'assets/media/profile/profile-picture.png';
  //     },
  //   });
  // }

  // sendChat(id: string): void {
  //   if (this.messageText.trim() === '' && this.file == null) return;
  //   if (
  //     this.currentUser?.role === this.userRole.OrganizationAdmin ||
  //     this.currentUser?.role === this.userRole.Assistant
  //   )
  //     return;

  //   this.isChatSending = true;
  //   const createChatModel: CreateChatModel = {
  //     patientRecordCaseId: id,
  //     patientName: this.patientHeaderInformations.name,
  //     patientSurname: this.patientHeaderInformations.lastName,
  //     patientRecordCaseNumber:
  //       this.patientHeaderInformations.patientRecordCaseNumber,
  //     createdUserName: this.currentUser?.name || '',
  //     message: this.messageText || '',
  //     expertUserName: this.patientHeaderInformations?.expertUserName || '',
  //     generalPractitionerUserName:
  //       this.patientHeaderInformations?.generalPractitionerUserName || '',
  //     file: this.file,
  //   };

  //   this.chatService.chat(createChatModel).subscribe({
  //     next: (res) => {
  //       if (res) {
  //         this.messageText = '';
  //         this.file = null;
  //         this.fileCount = null;

  //         this.getChatList(this.consultationId);
  //       }
  //     },

  //     complete: () => {
  //       this.isChatSending = false;
  //     },
  //   });
  // }

  // scrollToBottom(): void {
  //   const interval = setInterval(() => {
  //     if (this.chatContainer && this.chatContainer.nativeElement) {
  //       this.chatContainer.nativeElement.scrollTop =
  //         this.chatContainer.nativeElement.scrollHeight + 200;
  //       clearInterval(interval);
  //     }
  //   }, 500);
  // }

  get hasAnySelectedImage(): any {
    return this.radioSelectedImage != null ? true : false;
  }

  getSelectedImage(): any {
    this.selectedImage =
      this.patientRecordCaseImages.find((image) => image.isSelected) || null;
    return this.selectedImage;
  }

  selectImage(imag: any) {
    this.radioSelectedImage = this.patientRecordCaseImages.find(
      (x) => x.id == imag.id
    );
  }

  onBodyRegionSelected(regionId: string): void {
    if (!this.dermAiCase || !regionId?.trim()) {
      return;
    }
    this.dermAiCase.bodyRegionId = regionId.trim();
  }

  sendReAnalysis(): void {
    this.toastService.showToast(
      this.translate.instant('notReadyConsultantReportDesc'),
      'warning'
    );
  }

  selectImageForReport(imageData: any, event: MouseEvent) {
    const isChecked = (event.target as HTMLInputElement).checked;

    imageData.isReportImage = isChecked;
    this.currentCaseData.isReportImage = isChecked;

    const selectedImage = this.patientRecordCaseImages.find(
      (image: any) => image.imageId === imageData.imageId
    );
    if (selectedImage) {
      selectedImage.isReportImage = isChecked;
    }
  }

  selectImageForReportFromHistory(imageData: any, event: MouseEvent) {
    const isChecked = (event.target as HTMLInputElement).checked;
    imageData.isReportImage = isChecked;
    this.fullscreenImage.isReportImage = isChecked;
  }

  updateHistoryImage;

  skinTypeTextHeader(): any {
    const skinTypeHeaderText = this.translate.instant('skinTypeHeader');
    switch (this.patientCaseDetails?.dermatologyCaseInformation?.skinType) {
      case SkinTypes.Type1:
        return `${skinTypeHeaderText} 1 `;

      case SkinTypes.Type2:
        return `${skinTypeHeaderText} 2 `;

      case SkinTypes.Type3:
        return `${skinTypeHeaderText} 3 `;

      case SkinTypes.Type4:
        return `${skinTypeHeaderText} 4 `;

      case SkinTypes.Type5:
        return `${skinTypeHeaderText} 5 `;

      case SkinTypes.Type6:
        return `${skinTypeHeaderText} 6 `;

      default:
        return '';
    }
  }

  generalAppearanceTextHeader(): any {
    let generalAppearanceText: string = '';

    if (
      this.patientCaseDetails?.dermatologyCaseInformation?.generalAppearance
        ?.freckles
    ) {
      generalAppearanceText += this.translate.instant('freckles') + ', ';
    }
    if (
      this.patientCaseDetails?.dermatologyCaseInformation?.generalAppearance
        ?.redHair
    ) {
      generalAppearanceText += this.translate.instant('redHair') + ', ';
    }
    if (
      this.patientCaseDetails?.dermatologyCaseInformation?.generalAppearance
        ?.lightColoredEyes
    ) {
      generalAppearanceText +=
        this.translate.instant('lightColoredEyes') + ', ';
    }
    if (generalAppearanceText.endsWith(', ')) {
      generalAppearanceText = generalAppearanceText.slice(0, -2);
    }
    return generalAppearanceText;
  }

  medicalHistoryTextHeader(): string {
    const info = this.patientCaseDetails?.dermatologyCaseInformation;
    const names = [
      ...(info?.riskFactors ?? []),
      ...(info?.dermatologicDiseases ?? []),
      ...(info?.diseaseCousingImmunosuppressions ?? []),
      ...(info?.neoplasticDiseases ?? []),
      ...(info?.otherDiseases ?? []),
    ]
      .map((element) =>
        localizeNamedReference(
          (key) => this.translate.instant(key),
          element,
          'medical'
        )
      )
      .filter((name): name is string => !!name);

    return names.join(', ');
  }

  medicationsTextHeader(): string {
    const names = (this.patientCaseDetails?.medications ?? [])
      .map((element) =>
        localizeNamedReference(
          (key) => this.translate.instant(key),
          element,
          'medication'
        )
      )
      .filter((name): name is string => !!name);

    return names.join(', ');
  }

  complatintsTextHeader(): any {
    let complatintsTextHeader: string = '';

    const lesionCharacteristic =
      this.patientCaseDetails?.dermatologyCaseInformation?.lesionCharacteristic;

    if (lesionCharacteristic?.bleeding) {
      complatintsTextHeader += this.translate.instant('bleeding') + ', ';
    }
    if (lesionCharacteristic?.pain) {
      complatintsTextHeader += this.translate.instant('pain') + ', ';
    }
    if (lesionCharacteristic?.itching) {
      complatintsTextHeader += this.translate.instant('itching') + ', ';
    }
    if (lesionCharacteristic?.ulceration) {
      complatintsTextHeader += this.translate.instant('ulceration') + ', ';
    }

    if (complatintsTextHeader.endsWith(', ')) {
      complatintsTextHeader = complatintsTextHeader.slice(0, -2);
    }

    return complatintsTextHeader;
  }

  changeTextHeader(): any {
    let changeHeaderText: string = '';

    const lesionCharacteristic =
      this.patientCaseDetails?.dermatologyCaseInformation?.lesionCharacteristic;

    if (lesionCharacteristic?.hasSizeChange) {
      changeHeaderText += this.translate.instant('size') + ', ';
    }
    if (lesionCharacteristic?.hasGreaterThan6mmChange) {
      changeHeaderText += this.translate.instant('greatherThan6mm') + ', ';
    }
    if (lesionCharacteristic?.hasBorderChange) {
      changeHeaderText += this.translate.instant('border') + ', ';
    }
    if (lesionCharacteristic?.hasColorChange) {
      changeHeaderText += this.translate.instant('color') + ', ';
    }

    if (changeHeaderText.endsWith(', ')) {
      changeHeaderText = changeHeaderText.slice(0, -2);
    }

    return changeHeaderText;
  }

  durationTextHeader(): any {
    let durationHeaderText: string = '';

    if (
      this.patientCaseDetails.dermatologyCaseInformation?.lesionCharacteristic
        ?.hasCongenital
    ) {
      durationHeaderText = this.translate.instant('congenital');
    } else {
      durationHeaderText =
        this.patientCaseDetails.dermatologyCaseInformation?.lesionCharacteristic
          ?.customCongenitalValue;
    }
    return durationHeaderText;
  }

  handleDoubleClickForCurrentImage(image: any): void {
    this.currentCaseData.imageId = image.imageId;
    this.currentCaseData.patientRecordCaseId = image.patientRecordId;
    this.currentCaseData.src = image.src;
    this.currentCaseData.isSelected = image.isSelected;
    this.currentCaseData.isReportImage = image.isReportImage;

    document.getElementById('allCaseImages').style.display = 'none';
    const caseImageTab = document.querySelector('[href="#caseImage"]');
    if (caseImageTab) {
      (caseImageTab as HTMLElement).click();
    }
  }

  handleDoubleClickForHistoryImage(image: any) {
    this.showImageGallery = false;
    this.fullscreenImage.imageId = image.imageId;
    this.fullscreenImage.isReportImage = image.isReportImage;
    this.fullscreenImage.isSelected = image.isSelected;
    this.fullscreenImage.patientRecordCaseId = image.patientRecordCaseId;
    this.fullscreenImage.src = image.src;
  }

  closeFullscreenImage() {
    this.showImageGallery = true;
  }

  showAiImagesFullscreen(image: any) {
    this.showImageGalleryAi = false;
    this.fullscreenImageAi = image;
  }

  closeAiImagesFullscreen() {
    this.showImageGalleryAi = true;
    this.fullscreenImageAi = null;
  }

  updateCurrentCaseData(index) {
    const selectedImage = this.patientRecordCaseImages[index];
    if (selectedImage) {
      this.currentCaseData.imageId = selectedImage.imageId;
      this.currentCaseData.patientRecordCaseId = selectedImage.patientRecordId;
      this.currentCaseData.src = selectedImage.src;
      this.currentCaseData.isSelected = selectedImage.isSelected;
      this.currentCaseData.isReportImage = selectedImage.isReportImage;
    }
  }

  updateHistoryCaseData(index) {
    const selectedImage = this.patientHistoryImages[index];
    if (selectedImage) {
      selectedImage.images.forEach((item) => {
        this.historyCaseDataList.push({
          src: item.fileData || null,
          isSelected: item.isSelected,
          isReportImage: item.isReportImage,
          imageId: item.imageId,
          patientRecordCaseId: item.patientRecordCaseId,
        });
      });
    }
  }

  prevImage() {
    if (this.selectedImageIndex > 0) {
      this.selectedImageIndex--;
    } else {
      this.selectedImageIndex = this.patientRecordCaseImages.length - 1;
    }
    this.updateCurrentCaseData(this.selectedImageIndex);
  }

  nextImage() {
    if (this.selectedImageIndex < this.patientRecordCaseImages.length - 1) {
      this.selectedImageIndex++;
    } else {
      this.selectedImageIndex = 0;
    }
    this.updateCurrentCaseData(this.selectedImageIndex);
  }

  handleMouseMove(event: MouseEvent) {
    const button = document.getElementById('myAccordionButton');
    if (button) {
      const rect = button.getBoundingClientRect();
      const threshold = 50;
      if (event.clientY < rect.top + threshold) {
        this.openAccordion('collapseOne');
      }
    }
  }

  openAccordion(id) {
    const element = document.getElementById(id);
    if (element && !element.classList.contains('show')) {
      element.classList.add('show');
    }
  }

  closeAccordion(id) {
    const element = document.getElementById(id);
    if (element && element.classList.contains('show')) {
      element.classList.remove('show');
    }
  }

  // DermoScan: chat disabled
  // getOtherUserName(): void {
  //   const isOtherUserChatExist = this.chatList?.some(
  //     (chat) => chat.createdUserId !== this.currentUser?.id
  //   );
  //   if (isOtherUserChatExist) {
  //     this.otherUserName = this.chatList?.find(
  //       (chat) => chat.createdUserId !== this.currentUser?.id
  //     )?.createdUserName;
  //   }
  // }

  lang(): string {
    return localStorage.getItem('selectedLanguage');
  }

  isSelectedAdvancedExamination() {
    this.updateConclusionOutput(null, ADVANCED_EXAMINATION);
  }

  async getAiImages() {
    if (!this.consultationId) return;
    this.isAiLoading = true;
    try {
      const res = await this.consultationsService.getAiImages(
        this.consultationId,
        () => { },
        (err) => { }
      );
      if (res) {
        const imageKeys = [
          'gaugeImage',
          'radarChartImage',
          'lesionSpaceImage',
          'cbirImage',
          'blendedImage',
          'spaceImage',
          'saturationSpaceImage',
          'cbir1Image',
          'cbir2Image',
          'cbir3Image',
          'cbir4Image',
          'cbir5Image',
        ];

        imageKeys.forEach((key) => {
          if (res[key] && !res[key].startsWith('data:image')) {
            res[key] = `data:image/jpeg;base64,${res[key]}`;
          }
        });

        // CBIR imajlarından en az biri varsa AI Report tab'ı göster
        const hasCbirImages = !!(
          res.cbir1Image ||
          res.cbir2Image ||
          res.cbir3Image ||
          res.cbir4Image ||
          res.cbir5Image
        );

        this.aiImages = {
          ...this.aiImages,
          ...res,
          allImagesExist: hasCbirImages
        };
      }
    } catch (error) {
      console.error(error);
      this.aiImages.allImagesExist = false;
    } finally {
      this.isAiLoading = false;
    }
  }
}
